module.exports = __webpack_public_path__ + "static/media/logo_microhouse.5e24a4d1.png";